type requestObj = {
  items: {
    id: string | number;
    properties?: {
      [key: string]: string | number;
    };
    quantity: string | number;
  }[];
};

const addCart = async (requestObj: requestObj) => {
  await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(requestObj),
  });
};

export { addCart };
